import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { useState } from 'react';
import ClickableIcon from 'components/common/icon/clickable-icon';

const StyledLink = styled(NavLink)`
  color: ${props => props.theme.colors.black};
  font-family: ${props => props.theme.fonts};
  font-size: 1.2rem;
  text-decoration: none;
  cursor: pointer;
  display: inline-block;
  margin: 5px 0 0 -20px;
  padding-bottom: 3px;
  padding-top: 3px;
  &.active {
    border-bottom-color: white;
  }
  @media (max-width: 1200px) {
    font-size: 1.2rem;
    font-family: ${props => props.theme.fonts};
  }
`;

const Ul = styled.ul`
  clear: both;
  overflow: hidden;
  text-align: left;
  transition: height 0.4s ease;
`;

const Li = styled.li`
  list-style: none;
`;

// A dropdown inside another one (isNested) sits in its list like a link, without a separator.
const Nav = styled.nav<{ isNested: boolean }>`
  background: #f2f2f2;
  margin-left: ${props => (props.isNested ? '-25px' : '0')};
  :first-child {
    margin-top: ${props => (props.isNested ? '0' : '35px')};
  }
  .slide ${Li} {
    margin: 0px auto 15px 0px;
    :last-child {
      margin: 0px;
    }
  }
`;
const ArrowIcon = styled(ClickableIcon).attrs({
  name: 'arrow'
})`
  font-size: 0.5rem;
  color: ${props => props.theme.colors.black};
  margin-right: 20px;
`;
const Div = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
`;

type TitleType = {
  isOpen?: boolean;
};

const Title = styled.span<TitleType>`
  margin: 0px 10px 0px 5px;
  background: #f2f2f2 0% 0% no-repeat padding-box;
  color: ${props => props.theme.colors.black};
  opacity: 1;
  font-size: 12px;
  font-family: ${props => props.theme.fonts.semiBold};
  cursor: pointer;
  display: block;

  :hover {
    color: ${props => props.theme.colors.red};
  }
  &::after {
    font-family: ${props => props.theme.fonts.bold};
    float: right;
    font-weight: bold;
    font-size: 1.5rem;
    right: 10%;
  }
`;

const Input = styled.input`
  position: absolute;
  opacity: 0;
  height: 0px;
  text-decoration: none;
`;
const Saperetor = styled.div`
  height: 10px;
  width: 90%;
  margin-left: 5px;
  margin-bottom: 10px;
  border-bottom: 1px solid #d6d9de;
`;

type NavRoute = { route: string; routeTitle: string };
// A group of routes inside a dropdown, shown as a dropdown of its own.
type NavGroup = { id: string; title: string; routes: NavRoute[] };

type NavBarDropdown = {
  routes: Array<NavRoute | NavGroup>;
  id: string;
  title: string;
  isNested?: boolean;
};
export const NavBarDropdown = ({ routes, id, title, isNested = false }: NavBarDropdown) => {
  const [open, setOpen] = useState(false);
  return (
    <Nav isNested={isNested}>
      <label htmlFor={id}>
        <Div>
          <Title isOpen={open}>{title}</Title>
          <ArrowIcon onClick={() => setOpen(!open)} />
          <Input onClick={() => setOpen(!open)} type="checkbox" id={id} />
        </Div>
      </label>

      <Ul hidden={!open} className={open ? 'slide' : ''}>
        {routes &&
          routes.map(route =>
            'routes' in route ? (
              <Li key={route.id}>
                <NavBarDropdown routes={route.routes} id={route.id} title={route.title} isNested />
              </Li>
            ) : (
              <Li key={route.route}>
                <StyledLink to={route.route}>{route.routeTitle}</StyledLink>
              </Li>
            )
          )}
      </Ul>
      {!isNested && <Saperetor />}
    </Nav>
  );
};
export default NavBarDropdown;
